export const competitors = [
  {
    id: 0,
    color: "#d3a01f",
    icon: "mdi-podium-gold"
  },
  {
    id: 1,
    color: "#C0C0C0",
    icon: "mdi-podium-silver"
  },
  {
    id: 2,
    color: "#CD7F32",
    icon: "mdi-podium-bronze"
  },
]